<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'100px'"
      :search-btn-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      is-list
      :before-query-search="beforeQuerySearch"
      @afterFetchOriginalData="getLowTableData"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <!-- SKU -->
        <el-col :span="colSpan">
          <el-form-item label="SKU" prop="sku">
            <BjInputCode
              v-model="queryParams.sku"
              :placeholder="$t('InternalOrder.number')"
              comma
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- 采购员 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.buyerName')" prop="buyerName">
            <BjInput
              v-model="queryParams.buyerName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- 采购类型 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.type')" prop="type">
            <BjSelectLov v-model="queryParams.type" :clearable="false" :option-list="PURCHASE_TYPE_NUMBER" />
          </el-form-item>
        </el-col>
        <!-- 是否参与成本统计 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseCostDown.statistics')" prop="isCost">
            <BjSelectLov v-model="queryParams.isCost" :clearable="false" :option-list="STATUS_YES_TRUE" />
          </el-form-item>
        </el-col>
        <!-- 基准日期 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseCostDown.Base')">
            <BjDatePicker v-model="queryParams.creationDateBegin" />
          </el-form-item>
        </el-col>
        <!-- 核算日期 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseCostDown.Calculate')">
            <BjDateTimerPicker v-model="queryParamsTime_documentDate" />
          </el-form-item>
        </el-col>

        <!-- css空壳 -->
        <!-- <el-col :span="colSpan">
          <div style="width:30px;height: 10px;"> </div>
        </el-col> -->
        <!-- <el-col :span="colSpan">
          <div style="width:30px;height: 10px;"> </div>
        </el-col> -->
        <el-col :span="colSpan">
          <div style="width:30px;height: 10px;"> </div>
        </el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" @click="onExport">{{ $t('exportText') }}</el-button>
        </el-col>
      </template>

      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'"
          :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
          :prop="col.prop"
          :label="col.label"
          :width="col.width || 'auto'"
          :fixed="col.fixed || false"
          align="center"
          class-name="item"
          :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'sku'">
                <span class="link">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'contractNo'">
                <span class="link">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'creationDate'">
                <span>{{ scope.row[col.prop] | timeFilters }}</span>
              </template>
              <el-switch
                v-else-if="col.prop === 'isCost'"
                v-model="scope.row[col.prop]"
                :active-value="true"
                :inactive-value="false"
                @change="switchButton($event, scope.row)"
              />
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 降本总金额 -->
    <div style="margin-right:15px;margin-top:15px;float: right;color: #082dc3;font-weight: 700;font-size: 23px;">{{ $t('BusinessPurchaseCostDown.Total') }} ： <span style="color:#082dc3">{{ total }}</span> </div>
  </div>
</template>
<script>
const start = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);

import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
import { STATUS_YES_TRUE, PURCHASE_TYPE_NUMBER} from '@/utils/constants';
import { downloadBlob } from '@/utils/index';
import moment from 'moment';
export default {
  name: 'BusinessPurchaseGetLow',
  components: { },
  mixins: [pageMiXin],
  props: {
    businessType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      PURCHASE_TYPE_NUMBER,
      STATUS_YES_TRUE,
      selection: false,
      colSpan: 6,
      getLowData: [],
      // 查询参数
      queryApi: purchaseApi.getSkuPurchaseCostList,
      queryParamsTime_documentDate: [start, new Date()],
      queryParams: {
        businessType: this.businessType,

        sku: null,
        type: 1,
        isCost: true,
        buyerName: null,
        creationDateBegin: moment(start).format('YYYY-MM-DD HH:mm:ss'),
        creationDateEndStart: moment(start).format('YYYY-MM-DD HH:mm:ss'),
        creationDateEnd: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      },
      labelsVersion: 13,

      labelList: [
        { label: 'SKU', prop: 'sku', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseCostDown.number'), prop: 'contractNo', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseCostDown.BasePrice'), prop: 'guidePrice', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseCostDown.price'), prop: 'price', isCheck: true, disabled: false },
        { label: this.$t('BjDialogListConfig.Purchasequantity'), prop: 'qty', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseCostDown.amount'), prop: 'totalPrice', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseCostDown.Cost'), prop: 'totalCost', isCheck: true, disabled: false, width: 115 },
        { label: this.$t('goodsPage.buyerName'), prop: 'buyerName', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseCostDown.time'), prop: 'creationDate', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseCostDown.statistics'), prop: 'isCost', isCheck: true, disabled: false },
      ]
    };
  },
  computed: {
    total() {
      if (this.getLowData.length > 0) {
        return this.getLowData.reduce((pre, cur) => {
          pre = pre + cur.totalCost;
          return pre;
        }, 0);
      } else {
        return 0;
      }
    }
   },
  watch: {
    // 生成日期
    queryParamsTime_documentDate(v) {
      this.queryParams.creationDateEndStart = (v || [])[0];
      this.queryParams.creationDateEnd = (v || [])[1];
    },
  },
  methods: {
    // 获取tableData数据
    getLowTableData(data) {
      this.getLowData = data;
    },

    // 滑块方法
    switchButton(e, row) {
      // console.log(e, row,'滑块');
      const API_DATA = {
        id: row.id,
        isCost: e,
      };
      this.$confirm(this.$t('BarcodeConfiguration.Operation'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          purchaseApi.updatePurchaseGoodsStatus(API_DATA).then(res => {
            // console.log(res,'滑块修改');
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 1000);
          });
        })
        .catch(() => {
          row.isCost = !row.isCost;
        });
    },

    /** 导出 */
    onExport() {
      purchaseApi.costReportApplys(this.queryParams).then(res => {
        downloadBlob(res, this.$t('BusinessPurchaseApply.Reduction') + new Date().toLocaleString() + '.xlsx');
      });
    },

    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams.creationDateBegin = moment(start).format('YYYY-MM-DD HH:mm:ss');
      this.queryParamsTime_documentDate = [moment(start).format('YYYY-MM-DD HH:mm:ss'), moment(new Date()).format('YYYY-MM-DD HH:mm:ss')];
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 搜索按钮操作 */
    beforeQuerySearch(e) {
      var date = new Date(e.creationDateBegin); // 你的日期时间字符串
      var creationDateBegin = date.getTime(); // 转换为时间戳
      var date1 = new Date(e.creationDateEndStart); // 你的日期时间字符串
      var creationDateEndStart = date1.getTime(); // 转换为时间戳
      if (creationDateBegin > creationDateEndStart) {
        this.msgError(this.$t('BusinessPurchaseCostDown.The'));
        e.creationDateBegin = moment(start).format('YYYY-MM-DD HH:mm:ss');
        e.creationDateEndStart = moment(start).format('YYYY-MM-DD HH:mm:ss');
        e.creationDateEnd = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.queryParams.creationDateBegin = e.creationDateBegin;
        this.queryParams.creationDateEndStart = e.creationDateEndStart;
        this.queryParams.creationDateEnd = e.creationDateEnd;
        this.queryParamsTime_documentDate = [e.creationDateEndStart, e.creationDateEnd];
      }
      return new Promise(resolve => {
        resolve(e);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
